/* =============================================
   THEME.JS — Vuota-style Shopify Theme
   ============================================= */

/* ---- Helpers ---- */
function money(cents) {
  return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

/* =============================================
   CART DRAWER
   ============================================= */
const drawer        = document.getElementById('cart-drawer');
const drawerOverlay = document.getElementById('cart-drawer-overlay');
const drawerBody    = document.getElementById('cart-drawer-body');
const drawerFooter  = document.getElementById('cart-drawer-footer');
const drawerCount   = document.querySelectorAll('.js-cart-count');

function openDrawer() {
  if (!drawer) return;
  drawer.classList.add('open');
  drawerOverlay.classList.add('open');
  document.body.style.overflow = 'hidden';
  fetchAndRenderCart();
}

function closeDrawer() {
  if (!drawer) return;
  drawer.classList.remove('open');
  drawerOverlay.classList.remove('open');
  document.body.style.overflow = '';
}

async function fetchAndRenderCart() {
  try {
    const res  = await fetch('/cart.js');
    const cart = await res.json();
    renderDrawer(cart);
    updateCartCount(cart.item_count);
  } catch(e) {
    if (drawerBody) drawerBody.innerHTML = '<p class="cart-drawer__empty">Could not load cart.</p>';
  }
}

function renderDrawer(cart) {
  if (!drawerBody) return;
  if (cart.item_count === 0) {
    drawerBody.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
    if (drawerFooter) drawerFooter.style.display = 'none';
    return;
  }
  if (drawerFooter) {
    drawerFooter.style.display = 'block';
    document.getElementById('cart-drawer-subtotal').textContent = money(cart.total_price);
  }
  drawerBody.innerHTML = cart.items.map(item => `
    <div class="drawer-item" data-key="${item.key}">
      <img class="drawer-item__img" src="${item.image}" alt="${item.product_title}">
      <div class="drawer-item__info">
        <div class="drawer-item__title">${item.product_title}</div>
        ${item.variant_title && item.variant_title !== 'Default Title'
          ? `<div class="drawer-item__variant">${item.variant_title}</div>` : ''}
        <div class="drawer-item__price">${money(item.final_line_price)}</div>
        <div class="drawer-item__qty">
          <button onclick="changeQty('${item.key}', ${item.quantity - 1})">−</button>
          <span>${item.quantity}</span>
          <button onclick="changeQty('${item.key}', ${item.quantity + 1})">+</button>
        </div>
      </div>
      <button class="drawer-item__remove" onclick="changeQty('${item.key}', 0)" title="Remove">×</button>
    </div>
  `).join('');
}

async function changeQty(key, qty) {
  try {
    const res  = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    const cart = await res.json();
    renderDrawer(cart);
    updateCartCount(cart.item_count);
  } catch(e) { console.error(e); }
}

async function addToCart(variantId, quantity = 1) {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity })
  });
  if (!res.ok) throw new Error('Add to cart failed');
  await fetchAndRenderCart();
}

function updateCartCount(n) {
  drawerCount.forEach(el => { el.textContent = n; });
}

/* Bind open/close */
document.querySelectorAll('.js-open-cart').forEach(el =>
  el.addEventListener('click', openDrawer)
);
document.getElementById('cart-drawer-close')?.addEventListener('click', closeDrawer);
document.getElementById('cart-drawer-overlay')?.addEventListener('click', closeDrawer);

/* Load count on page load */
fetch('/cart.js').then(r => r.json()).then(c => updateCartCount(c.item_count)).catch(() => {});

/* =============================================
   PRODUCT PAGE — variant + ATC
   ============================================= */
const productForm = document.getElementById('product-form');
if (productForm) {
  let selectedId = parseInt(productForm.dataset.firstVariant);

  // Variant buttons
  productForm.querySelectorAll('.variant-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.classList.contains('sold-out')) return;
      productForm.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      selectedId = parseInt(btn.dataset.variantId);
      // Update price
      const priceEl = document.getElementById('product-price');
      if (priceEl && btn.dataset.price) priceEl.textContent = money(parseInt(btn.dataset.price));
    });
  });

  // Thumbnail switcher
  document.querySelectorAll('.product-page__thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const main = document.getElementById('product-main-img');
      if (main) main.src = thumb.dataset.full;
      document.querySelectorAll('.product-page__thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  // ATC
  const atcBtn   = document.getElementById('atc-btn');
  const feedback = document.getElementById('atc-feedback');
  if (atcBtn) {
    atcBtn.addEventListener('click', async () => {
      if (atcBtn.disabled) return;
      atcBtn.textContent = 'Adding…';
      atcBtn.disabled = true;
      try {
        await addToCart(selectedId, 1);
        if (feedback) feedback.textContent = 'Added to cart';
        atcBtn.textContent = 'Add to Cart';
        atcBtn.disabled = false;
        openDrawer();
        setTimeout(() => { if (feedback) feedback.textContent = ''; }, 3000);
      } catch(e) {
        if (feedback) feedback.textContent = 'Error — please try again';
        atcBtn.textContent = 'Add to Cart';
        atcBtn.disabled = false;
      }
    });
  }
}

/* =============================================
   ARCHIVE LIGHTBOX
   ============================================= */
const lightbox     = document.getElementById('lightbox');
const lightboxImg  = document.getElementById('lightbox-img');
let lbImages       = [];
let lbIndex        = 0;

if (lightbox) {
  lbImages = Array.from(document.querySelectorAll('.archive-grid__item img'));

  lbImages.forEach((img, i) => {
    img.parentElement.addEventListener('click', e => {
      e.preventDefault();
      lbIndex = i;
      showLightbox(i);
    });
  });

  function showLightbox(i) {
    lightboxImg.src = lbImages[i].src.replace(/&width=\d+/, '&width=1200');
    lightbox.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeLightbox() {
    lightbox.classList.remove('open');
    document.body.style.overflow = '';
  }

  document.getElementById('lightbox-close')?.addEventListener('click', closeLightbox);
  document.getElementById('lightbox-prev')?.addEventListener('click', () => {
    lbIndex = (lbIndex - 1 + lbImages.length) % lbImages.length;
    showLightbox(lbIndex);
  });
  document.getElementById('lightbox-next')?.addEventListener('click', () => {
    lbIndex = (lbIndex + 1) % lbImages.length;
    showLightbox(lbIndex);
  });
  lightbox.addEventListener('click', e => {
    if (e.target === lightbox) closeLightbox();
  });
  document.addEventListener('keydown', e => {
    if (!lightbox.classList.contains('open')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') { lbIndex = (lbIndex - 1 + lbImages.length) % lbImages.length; showLightbox(lbIndex); }
    if (e.key === 'ArrowRight') { lbIndex = (lbIndex + 1) % lbImages.length; showLightbox(lbIndex); }
  });
}

/* =============================================
   MOBILE NAV
   ============================================= */
document.getElementById('nav-toggle')?.addEventListener('click', () => {
  document.getElementById('mobile-nav')?.classList.add('open');
  document.body.style.overflow = 'hidden';
});
document.getElementById('mobile-nav-close')?.addEventListener('click', () => {
  document.getElementById('mobile-nav')?.classList.remove('open');
  document.body.style.overflow = '';
});

/* =============================================
   CART PAGE (full /cart)
   ============================================= */
const cartPageRoot = document.getElementById('cart-page-root');
if (cartPageRoot) {
  async function renderCartPage() {
    const res  = await fetch('/cart.js');
    const cart = await res.json();
    const container = document.getElementById('cart-page-items');
    const subtotalEl = document.getElementById('cart-page-subtotal');
    const emptyEl    = document.getElementById('cart-page-empty');
    const footerEl   = document.getElementById('cart-page-footer');

    updateCartCount(cart.item_count);

    if (cart.item_count === 0) {
      container.innerHTML = '';
      if (emptyEl) emptyEl.style.display = 'block';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }
    if (emptyEl) emptyEl.style.display = 'none';
    if (footerEl) footerEl.style.display = 'block';
    if (subtotalEl) subtotalEl.textContent = 'Subtotal: ' + money(cart.total_price);

    container.innerHTML = cart.items.map(item => `
      <div class="cart-page__item">
        <img class="cart-page__item-img" src="${item.image}" alt="${item.product_title}">
        <div>
          <div class="cart-page__item-title">${item.product_title}</div>
          ${item.variant_title && item.variant_title !== 'Default Title'
            ? `<div class="cart-page__item-variant">${item.variant_title}</div>` : ''}
          <div class="cart-page__item-qty">
            <button onclick="cartPageQty('${item.key}', ${item.quantity - 1})">−</button>
            <span>${item.quantity}</span>
            <button onclick="cartPageQty('${item.key}', ${item.quantity + 1})">+</button>
          </div>
          <button class="cart-page__item-remove" onclick="cartPageQty('${item.key}', 0)">Remove</button>
        </div>
        <div class="cart-page__item-price">${money(item.final_line_price)}</div>
      </div>
    `).join('');
  }

  async function cartPageQty(key, qty) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    renderCartPage();
  }

  renderCartPage();
}
